import { safeDecodeURIComponent } from './safeDecodeURIComponent';
import { apiHolder as api } from 'api';
const TARGET_FUNCS = ['mbox:getMessageData', 'mbox:decryptMessagePart', 'mbox:packMessages', 'readpack.jsp', 'readdata.jsp'];
export const shouldTagUserClick = (url) => {
    if (!url)
        return false;
    const decoded = safeDecodeURIComponent(url);
    return TARGET_FUNCS.some(func => url.includes(func) || decoded.includes(func));
};
export const getTrackedUrl = (url) => {
    if (!url || !shouldTagUserClick(url))
        return undefined;
    const decoded = safeDecodeURIComponent(url);
    if (url.includes('trigger_type=user_click') || decoded.includes('trigger_type=user_click')) {
        return url;
    }
    const httpApi = api.api.getDataTransApi();
    return httpApi.buildUrl(url, { trigger_type: 'user_click' });
};
